module.exports = __webpack_public_path__ + "static/media/carpooling3.1fa44453.PNG";